import * as R from 'ramda'
import { queryFromString } from 'helpers/url'
import * as RE from 'helpers/ramda-ext'
import {
  ALL_PRODUCTS_SCOPE_URI,
  CATALOG_PAGE_NAME,
  PACKAGES_SEGMENT_URI,
  PRODUCT_PAGE_NAME,
  PRODUCT_SEGMENT_URI,
  SALEHOME_SEGMENT_URI,
  SELECTION_SEGMENT_URI,
  UNIVERSES_PAGE_NAME
} from 'constants/navigation'
import { ONE_TRUST_URI_QUERY_PARAM_KEY } from 'constants/oneTrust'
import {
  GetLocationChangeOperationCode,
  GetPageNameFromAction,
  GetPageNameFromUri,
  HasNoCypher,
  HasOneTrustQuery,
  IsAllProductsPathname,
  IsCatalogOrUniverseOrSaleSlugPageAction,
  IsCatalogOrUniverseOrSaleSlugPagePath,
  IsCatalogOrUniversePageAction,
  IsCatalogOrUniversePagePath,
  IsPackagesPagePath,
  IsProductPagePath,
  IsSaleHomePageAction,
  IsProductPageAction,
  GetLocationChangeQuery,
  IsSaleHomePagePath,
  IsKeyUnchanged,
  IsSelectionPagePath
} from './router.types'

export const isAllProductsPathname: IsAllProductsPathname = R.compose(
  R.both(
    R.pipe(R.nth(2), R.equals(ALL_PRODUCTS_SCOPE_URI)),
    R.pipe(R.nth(3), R.equals(PRODUCT_SEGMENT_URI), R.not)
  ),
  R.filter(R.complement(R.isEmpty)),
  R.split('/')
)

export const isCatalogOrUniverseOrSaleSlugPagePath: IsCatalogOrUniverseOrSaleSlugPagePath = R.compose(
  R.both(
    R.pipe(R.length, R.contains(R.__, [2, 3, 4])),
    R.pipe(R.nth(1), R.equals(SALEHOME_SEGMENT_URI), R.not)
  ),
  R.filter(RE.isNotEmptyOrNil),
  R.split('/')
)

export const isCatalogOrUniverseOrSaleSlugPageAction: IsCatalogOrUniverseOrSaleSlugPageAction = R.pipe(
  R.path(['payload', 'location', 'pathname']),
  isCatalogOrUniverseOrSaleSlugPagePath
)

export const isCatalogOrUniversePagePath: IsCatalogOrUniversePagePath = R.compose(
  R.pipe(R.length, R.contains(R.__, [3, 4])),
  R.filter(RE.isNotEmptyOrNil),
  R.split('/')
)

export const isCatalogOrUniversePageAction: IsCatalogOrUniversePageAction = R.compose(
  isCatalogOrUniversePagePath,
  R.path(['payload', 'location', 'pathname'])
)

export const isSaleHomePagePath: IsSaleHomePagePath = R.compose(
  R.pipe(R.nth(1), R.equals(SALEHOME_SEGMENT_URI)),
  R.filter(RE.isNotEmpty),
  R.split('/')
)

export const isSaleHomePageAction: IsSaleHomePageAction = R.pipe(
  R.path(['payload', 'location', 'pathname']),
  isSaleHomePagePath
)

/*
** The '/' are needed to be escaped because the generator is a string.
*/
/* eslint-disable no-useless-escape */
export const isPackagesPagePath: IsPackagesPagePath = R.test(new RegExp(`\/${PACKAGES_SEGMENT_URI}(?!\/${SELECTION_SEGMENT_URI})`))

export const isSelectionPagePath: IsSelectionPagePath = R.test(new RegExp(`\/${SELECTION_SEGMENT_URI}\/?`))

export const isProductPagePath: IsProductPagePath = R.test(new RegExp(`\/${PRODUCT_SEGMENT_URI}\/`))
/* eslint-enable no-useless-escape */

export const isProductPageAction: IsProductPageAction = R.pipe(
  R.path(['payload', 'location', 'pathname']),
  isProductPagePath
)

export const getLocationChangeQuery: GetLocationChangeQuery = R.pipe(
  R.path(['payload', 'location', 'search']),
  queryFromString
)

export const isKeyUnchanged: IsKeyUnchanged = (action1, action2) => (
  getLocationChangeQuery(action1).key === getLocationChangeQuery(action2).key
)

export const getLocationChangeOperationCode: GetLocationChangeOperationCode = R.pipe(
  R.path(['payload', 'location', 'pathname']),
  R.split('/'),
  R.nth(1),
  R.defaultTo(''),
  R.toUpper
)

export const hasNoCypher: HasNoCypher = R.pipe(
  getLocationChangeQuery,
  R.prop('cypherSSO'),
  R.isNil
)

export const hasOneTrustQuery: HasOneTrustQuery = R.pipe(
  getLocationChangeQuery,
  R.prop(ONE_TRUST_URI_QUERY_PARAM_KEY),
  RE.isNotNil
)

export const getPageNameFromAction: GetPageNameFromAction = R.cond([
  [isSaleHomePageAction, R.always(UNIVERSES_PAGE_NAME)],
  [isCatalogOrUniversePageAction, R.always(CATALOG_PAGE_NAME)],
  [isProductPageAction, R.always(PRODUCT_PAGE_NAME)],
  [R.T, R.always('/')]
])

export const getPageNameFromUri: GetPageNameFromUri = R.cond([
  [isSaleHomePagePath, R.always(UNIVERSES_PAGE_NAME)],
  [isCatalogOrUniversePagePath, R.always(CATALOG_PAGE_NAME)],
  [isProductPagePath, R.always(PRODUCT_PAGE_NAME)],
  [R.T, R.always('/')]
])
